import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import {MatSnackBar} from '@angular/material/snack-bar';


@Component({
  selector: 'app-uom-modal',
  templateUrl: './uom-modal.component.html',
  styleUrls: ['./uom-modal.component.scss']
})
export class UomModalComponent implements OnInit {

  isLoading = true;
  Errors = null;
  data = null;
  mode = null;
  Success = null

  uomForm = new FormGroup({
    name: new FormControl('', Validators.required),
    gender: new FormControl('', Validators.required),
    id: new FormControl(null, Validators.required),
  });

  constructor(private modal: ModalService, private _snackBar: MatSnackBar, public auth: SettingsService) { }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      name,
      id,
    } = this.uomForm.value;
    this.auth
      .postUom(
        name,
        id,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;
          console.log(resSuccess)

          if (this.data.success) {
            this.closeModal()
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });           }
          else {
            this.Errors = "Not successful, please try again"
            console.log("error")
          }
          
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr)
        }
      );
  }
  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {

    this.auth
      .getUom()
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      ); 
  }

  addNew() {
    this.mode = "add"
  }
  edit(uom) {
    this.mode = "edit"
    this.uomForm.patchValue({
      name: uom.name,
      id: uom.id ,
    });
    console.log(this.uomForm.value)
  }

  delete(title) {
    this.auth
      .delSet("/api/uom/deleteUOM", title.id)
      .subscribe(
        (resSuccess) => {
          this.data = this.data.filter(dattum => dattum.id !== title.id)
          this._snackBar.open('Deleted Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        },
        (resErr) => {
          this._snackBar.open('Error try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
  }

}
